import React, {Component} from 'react'
import Form from 'react-bootstrap/Form'
import Button from "react-bootstrap/Button"
import {validateYupSchema, yupToFormErrors} from "formik/dist/index"
import jwtClient from '../../JwtClient'
import * as yup from 'yup'
import {Address, DeliverTo} from "./Address";
import Track from '../Track';
import {Consignee} from "./Consignee";
import Alert from "react-bootstrap/Alert";
import {withFormik} from "formik";
import {Link, withRouter} from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import {LastMileService, schemaLastMileService} from "../LastMileService";
import {ItemsUA, schemaItem} from "./ItemsUA";
import Storage from "../../Storage";

export const phoneTemplate = /^\+380\s\d{2}\s\d{3}-\d{2}-\d{2}$/;

const schemaConsigneeAddress = yup.object().shape({
    zip: yup.string().when('$toDoor', (toDoor, schema) => (toDoor ? schema.matches(/^[0-9]{5}$/, 'Must be 5 digits').required('Required') : schema)),
    region: yup.string().when('$toDoor', (toDoor, schema) => (toDoor ? schema.required('Required') : schema)),
    city: yup.string().when('$toDoor', (toDoor, schema) => (toDoor ? schema.required('Required') : schema)),
    street: yup.string().when('$toDoor', (toDoor, schema) => (toDoor ? schema.required('Required') : schema)),
    house: yup.string().when('$toDoor', (toDoor, schema) => (toDoor ? schema.required('Required') : schema)),
    corpus: yup.string(),
    apartment: yup.string(),
});

const schemaNPIPickupPointAddress = yup.object().shape({
    region: yup.object().when('$toNpi', (toNpi, schema) => (toNpi ? schema.shape({
        value: yup.number(),
        label: yup.string(),
    }).typeError('Required') : schema.nullable())),
    city: yup.object().when('$toNpi', (toNpi, schema) => (toNpi ? schema.shape({
        value: yup.number(),
        label: yup.string(),
    }).typeError('Required') : schema.nullable())),
    street: yup.object().when('$toNpi', (toNpi, schema) => (toNpi ? schema.shape({
        value: yup.string(),
        label: yup.string(),
    }).typeError('Required') : schema.nullable())),
});

const schemaForm = yup.object().shape({
    lastMileService: schemaLastMileService,
    track: yup.string().min(5, 'Min length is 5').matches(/^[a-zA-Z0-9-]+$/, 'Must be any of: English letters, digits, hyphen').required('Required'),
    phone: yup.string().matches(phoneTemplate, 'Must match +380 11 123-45-67').required('Required'),
    name: yup.string().matches(/^[a-zA-Z-]+$/, 'Must be only English letters').required('Required'),
    surname: yup.string().matches(/^[a-zA-Z-]+$/, 'Must be only English letters').required('Required'),
    email: yup.string().email('Must be valid email').required('Required'),
    items: yup.array().of(schemaItem),
    npiPickupPointAddress: schemaNPIPickupPointAddress,
    consigneeAddress: schemaConsigneeAddress,
});

class InnerForm extends Component {
    countryCode = 'UA';
    state = {
        error: '',
        disableSubmit: false,
    };

    render() {
        const error = this.state.error || (this.props.status && this.props.status.error);
        const {
            handleSubmit,
            isSubmitting,
        } = this.props;
        return (
            <div>
                {!!error && <Alert variant="danger">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <LastMileService {...this.props}/>
                    <Track {...this.props} disableSubmit={this.disableSubmit}/>
                    <Consignee {...this.props} showError={this.showError}/>
                    <Address {...this.props} showError={this.showError}/>
                    <ItemsUA {...this.props}/>
                    <Row>
                        <Col sm="2">
                            <Button variant="primary" type="submit" disabled={isSubmitting || this.state.disableSubmit}>
                                Submit
                            </Button>
                        </Col>
                        <Col sm="2">
                            <Link to="/" className="btn btn-danger">Cancel</Link>
                        </Col>
                    </Row>
                </Form>
            </div>
        )
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        const {consigneeId} = this.props.values;
        if (consigneeId !== prevProps.values.consigneeId && !consigneeId) {
            this.clearAddressFields();
        }
        if (consigneeId !== prevProps.values.consigneeId && consigneeId) {
            this.setLastDeliveredAddress();
        }
    }

    setLastDeliveredAddress = () => {
        const {
            lastMileService,
            consigneeId,
        } = this.props.values;
        const {setFieldValue} = this.props;
        let url;
        if (consigneeId && lastMileService.code) {
            url = `/api/v1/consignee/${consigneeId}/last-delivered-address/${lastMileService.code}`
        } else {
            return
        }
        jwtClient.get(url)
            .then(response => {
                for (let i of response.data) {
                    if (i.deliver_to === DeliverTo.door) {
                        const {
                            zip,
                            region,
                            city,
                            street,
                            house,
                            corpus,
                            apartment,
                        } = i;
                        setFieldValue('consigneeAddress.zip', zip);
                        setFieldValue('consigneeAddress.region', region);
                        setFieldValue('consigneeAddress.city', city);
                        setFieldValue('consigneeAddress.street', street);
                        setFieldValue('consigneeAddress.house', house);
                        setFieldValue('consigneeAddress.corpus', corpus);
                        setFieldValue('consigneeAddress.apartment', apartment);
                    } else if (i.deliver_to === DeliverTo.pickupPoint) {
                        const {
                            region,
                            city,
                            street,
                        } = i;
                        if (lastMileService.code === 'NPI') {
                            setFieldValue('npiPickupPointAddress.region', region);
                            setFieldValue('npiPickupPointAddress.city', city);
                            setFieldValue('npiPickupPointAddress.street', street);
                        }
                    }
                }
            })
    };

    clearAddressFields = () => {
        const {setFieldValue} = this.props;
        setFieldValue('consigneeAddress.zip', '');
        setFieldValue('consigneeAddress.region', '');
        setFieldValue('consigneeAddress.city', '');
        setFieldValue('consigneeAddress.street', '');
        setFieldValue('consigneeAddress.house', '');
        setFieldValue('consigneeAddress.corpus', '');
        setFieldValue('consigneeAddress.apartment', '');
        setFieldValue('npiPickupPointAddress.region', '');
        setFieldValue('npiPickupPointAddress.city', '');
        setFieldValue('npiPickupPointAddress.street', '');
    };

    showError = error => {
        this.setState({error: JSON.stringify(error)});
    };

    disableSubmit = yes => {
        this.setState({disableSubmit: yes})
    };

}

function translate(values, countryOfDestination) {
    let consigneeAddress;
    if (values._deliverTo === DeliverTo.door) {
        consigneeAddress = values.consigneeAddress;
        consigneeAddress.deliver_to = DeliverTo.door;
    } else if (values._deliverTo === DeliverTo.pickupPoint && values.lastMileService.code === 'NPI') {
        const npi = values.npiPickupPointAddress;
        consigneeAddress = {
            region: npi.region,
            city: npi.city,
            street: npi.street,
            pickup_point_id: npi.id,
            deliver_to: DeliverTo.pickupPoint,
        };
    }
    return {
        track: values.track,
        last_mile_service: parseInt(values.lastMileService.id),
        customs_declaration: {
            country_of_destination: countryOfDestination,
            consignee_personal_data: {
                name: values.name,
                surname: values.surname,
                email: values.email,
                phone: values.phone,
            },
            items: values.items,
            consignee_address: consigneeAddress,
        },
    };
}

const PackageFormUA = withFormik({
    mapPropsToValues: () => ({
        _deliverTo: Storage.isHumAid() ? DeliverTo.pickupPoint : DeliverTo.door,
        lastMileService: {
            id: '',
            code: '',
        },
        track: '',
        consigneeId: '',
        phone: '',
        name: '',
        surname: '',
        email: '',
        items: [{description: '', quantity: 1, price: 0.00, hs_code: '68125000'}],

        // Either consignee address or address of lms pickup point
        npiPickupPointAddress: {
            region: null,
            city: null,
            street: null,
        },

        consigneeAddress: {
            zip: '',
            region: '',
            city: '',
            street: '',
            house: '',
            corpus: '',
            apartment: '',
        },
    }),

    validate: values => {
        let toDoor = false;
        let toNpi = false;
        if (values._deliverTo === DeliverTo.door) {
            toDoor = true;
        } else if (values._deliverTo === DeliverTo.pickupPoint && values.lastMileService.code === 'NPI') {
            toNpi = true;
        }
        try {
            validateYupSchema(values, schemaForm, true,
                {
                    toDoor: toDoor,
                    toNpi: toNpi,
                });
        } catch (err) {
            return yupToFormErrors(err);
        }
        return {};

    },

    handleSubmit: (values, formikBag) => {
        const countryOfDestination = 'UA';
        const formActionUrl = '/api/v1/package/create';
        const data = translate(values, countryOfDestination);
        jwtClient.post(formActionUrl, data)
            .then(response => {
                    if (response.status === 201) {
                        formikBag.props.history.push('/');
                    }
                }
            ).catch(error => {
            if (error.response) {
                formikBag.setStatus({error: `Error: ${JSON.stringify(error.response.data)}`});
            }
        });
        formikBag.setSubmitting(false);
    },

    displayName: 'PackageFormUA',
})(InnerForm);

export default withRouter(PackageFormUA);